import { css } from '@/styled-system/css';

export const placeholderPhoto = css({
  width: '100%',
  aspectRatio: '4 / 3',
});

export const placeholderData = css({
  // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- must equal the loading DataWrapper minBlockSize in listingCard.styles.ts
  height: '112px',
});
